
import { createStore } from "vuex";
import { auth } from "./auth.module";
import { context } from "./context.module";

const store = createStore({
  modules: {
    auth,
    context,
  },
});

export default store;
